<template>
  <div>
    <b-button @click="open = !open" icon-pack="fas" icon-left="question-circle">
    </b-button>
    <b-sidebar
      type="is-light"
      :fullheight="true"
      :fullwidth="false"
      :overlay="false"
      :right="true"
      :open.sync="open"
    >
      <slot></slot>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "help-sidebar",
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/components/help-sidebar/HelpSidebar.vue